<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Bonus Talepleri</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Bonus Talepleri</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Bonus Talep Logları

                <button class="btn btn-outline-primary btn-sm float-right" @click="reset">
                  <i class="fas fa-sync-alt"> </i> Sayfayı Yenile
                </button>

                <button class="btn btn-outline-primary btn-sm float-right" @click="automatic(true)"
                  style="margin-right:10px" v-if="!auto">
                  <i class="fas fa-play"> </i> Otomatik Yenileme Aç
                </button>
                <button class="btn btn-outline-danger btn-sm float-right" @click="automatic(false)"
                  style="margin-right:10px" v-else>
                  <i class="fas fa-stop"> </i> Durdur {{ sn }} sn
                </button>
              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col-xl-2 my-1">
                      <input type="text" placeholder="Müşteri ID" class="form-control form-control-sm"
                        v-model="search.code" />
                    </div>

                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.bonus">
                        <option value="0">Bonus Seçiniz</option>
                        <option v-for="data in bonuses" :key="data.id" :value="data.id">{{ data.name }}</option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.status">
                        <option disabled selected>Durum Seçiniz</option>
                        <option value="-1">Hepsi</option>
                        <option value="1">Bonus Verildi</option>
                        <option value="0">Bonus Verilmedi</option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.complate">
                        <option disabled selected>İşlem Durumu Seçiniz</option>
                        <option value="-1">Hepsi</option>
                        <option value="1">Tamamlanmış</option>
                        <option value="0">İşlem Sırasında</option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-info btn-sm w-100" @click="pagination">
                        <i class="fas fa-search"></i> Filtrele
                      </button>

                    </div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-danger btn-sm w-100" @click="reset">
                        Temizle
                      </button>
                    </div>
                  </div>
                  <br />
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Müşteri</th>
                        <th>İstek / Sonuç Zamanı</th>
                        <th>Bonus</th>

                        <th>İşlem Miktarları</th>

                        <th style="width: 250px">Açıklama</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in datas" :key="index">
                        <td>{{ ++index + (page - 1) * count }}</td>
                        <td>
                          {{ data.customer }} <br />
                          <b>{{ data.code }}</b> <br />
                          <badge :type="data.status ? 'success' : 'danger'"
                            :label="data.status ? 'Bonus Verildi' : 'Bonus Verilmedi'" />
                        </td>
                        <td>
                          <b>İstek Zamanı : </b>
                          {{ data.addDate | DateFormat }} <br />
                          <b>Sonuç Zamanı : </b> {{ data.date | DateFormat }}
                        </td>
                        <td>{{ data.bonus }}</td>

                        <td>
                          <span v-if="data.status">
                            <b>Yatırım : </b> {{ data.depositCount }} /
                            {{ data.depositAmount }} TL
                            <br />

                            <b>Çekim : </b>{{ data.withdrawCount }} /
                            {{ data.withdrawAmount }} TL
                            <br />
                            <b>Bonus : </b> {{ data.bonusCount }} /
                            {{ data.bonusAmount }} TL
                          </span>
                        </td>

                        <td>
                          {{ data.message }}
                        </td>
                        <td>
                          <router-link tag="button" :to="'/bonus-requests/' + data.id"
                            class="btn btn-outline-info btn-sm"><i class="fa fa-eye"></i></router-link>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="datas.length == 0" colspan="10" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="count" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import Badge from '../Common/Badge'
export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      datas: [],
      details: [],
      bonuses: [],
      overlay: false,
      search: {
        code: "",
        bonus: 0,
        status: -1,
        complate: -1
      },
      sn: 0,
      auto: false,
      timer: null
    };
  },
  components: {
    'badge': Badge,
  },
  methods: {
    automatic(status) {
      if (status) {
        this.auto = true;
        this.sn = 30;
        this.reset();
        this.timer = setInterval(() => {
          this.sn--
          if (this.sn <= 0) {
            this.sn = 30;
            this.reset();
          }
        }, 1000);
      } else {
        this.auto = false;
        this.sn = 30;
        this.reset();
        clearInterval(this.timer);
      }

    },
    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        code: "",
        bonus: 0,
        status: -1,
        complate: -1
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
      if (!type) this.overlay = true;
      this.$http
        .post("Bonus/ListRequest", {
          code: this.search.code,
          bonus: this.search.bonus,
          status: this.search.status,
          complate: this.search.complate,
          rowNumber: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else {
            this.datas = response.data;
            this.overlay = false;
          }
        });
    },

    getBonus() {
      this.$http.get("Bonus/ListAllBonuses").then((response) => {
        this.bonuses = response.data;
      });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
    ParseInt(value) {
      if (!value) return 0;

      return value;
    },
    ParseDouble(value) {
      if (!value) return 0.0;

      return value.toFixed(2);
    },
  },
  created() {
    this.getDatas();
    this.getDatas(true);
    this.getBonus();
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Bonus/BonusRequestList.vue